export default __webpack_public_path__ + "static/media/Family.10d1af80.jpg";